import { colors } from '@thndr/design-system';
import styled from 'styled-components';

export const TooltipIcon = styled.img`
  cursor: pointer;
  width: 16px;
  height: 16px;
  display: flex;
  transform: ${({theme})=>theme.rtl?"rotateY(180deg)":""};
`;

export const TooltipCard = styled.div<{
  show: boolean;
  offsetX: string;
  offsetY: string;
}>`
  position: absolute;
  transform: ${(props) =>
    `translateX(${props.offsetX}) translateY(${props.offsetY})`};
  height: max-content;
  padding: 8px 12px;
  background-color: #fff;
  border: 1px solid ${colors.blue60};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  opacity: ${(props) => (props.show ? 1 : 0)};
  visibility: ${(props) => (props.show ? 'visible' : 'hidden')};
  transition: opacity 0.2s ease-out, visibility 0.2s ease-out,
    transform 0.2s ease-out;
  z-index: 999;
`;

export const Title = styled.h5`
  line-height: 24px;
  font-size: 14px;
  color: ${colors.black};
  font-weight: 700;
  font-family: 'Dm Sans';
`;
